import { render, staticRenderFns } from "./informacionData.vue?vue&type=template&id=cd8ca414"
import script from "./informacionData.vue?vue&type=script&lang=js"
export * from "./informacionData.vue?vue&type=script&lang=js"
import style0 from "./informacionData.vue?vue&type=style&index=0&id=cd8ca414&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports